import request from '@/utils/request';

// 首页今日统计
export const todayStatistics = (data: any): any =>
  request({
    url: '/index/todaystatistics',
    data: data
  })

// 供应商排名
export const supplierRank = (data: any): any =>
  request({
    url: '/index/provider/ranklist',
    data: data
  })

// 商品排名
export const productRank = (data: any): any =>
  request({
    url: '/index/product/ranklist',
    data: data
  })

// 联创排名
export const lianchuangRank = (data: any): any =>
  request({
    url: '/index/lcrank',
    data: data
  })

// 销售商品排行
export const getUserProductRankList = (data: any): any =>
  request({
    url: '/product/product/ranklist',
    data: data
  })

// 商品销量统计
export const getProductSalesStatistics = (data: any): any =>
  request({
    url: '/provider/product/sellStatis',
    data: data
  })

// 分销员业绩统计
export const GetAgentEarningsList = (data: any): any =>
  request({
    url: '/agent/earninglist',
    data: data
  })

// 分销员团队业绩
export const getTeamEarningsList = (data: any): any =>
  request({
    url: '/agent/team/earnings',
    data: data
  })

// 奖励业绩统计
export const getRewardEarningList = (data: any): any =>
  request({
    url: '/agent/reward/earnings',
    data: data
  })

  
// 供应商首页
export const providerIndexStatistics = (data: any): any =>
  request({
    url: '/provider/homePage/providerHomePage',
    data
  })


  
// 供应商首页月销量
export const productSellStatisList = (data: any): any =>
  request({
    url: '/provider/homePage/productSellStatisList',
    data
  })

// 首页_供应商订单
export const providerOrderList = (data: any): any =>
  request({
    url: '/provider/order/list',
    data
  })


//商品销量统计详细规格
export const productspecSellStatis = (data: any): any =>
  request({
    url: '/provider/product/specSellStatis',
    data
  })